// extracted by mini-css-extract-plugin
export default {"nestedRow":"SalesTransactionBlock_nestedRow__dGbFT"};